import { List } from 'antd';
import styled from 'styled-components';
import GreetingSection from '../../../components/navbar/GreetingSection';
// import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import phone from '../../../assets/images/phone.svg';
import homeMembershipIcon from 'assets/images/support/login.svg';
import policies from 'assets/images/support/policies.svg';
import person from 'assets/images/support/person.svg';
import payment from 'assets/images/support/payment.svg';
import claim from 'assets/images/support/claim.svg';
import NotificationBellRed from 'assets/images/notification-bell-red.svg';
import userGuide from 'assets/images/f15-my-documents.svg';
import './FAQstyle.less';
import { Row, Col } from 'antd';
import { Button } from 'antd';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import { useLifeFaq } from 'hooks';
import { Spinner, GenericResult } from 'components';
import { useEffect, useState } from 'react';

export interface newLifeFaqList {
  Profile?: itemList[];
  Login?: itemList[];
  Policies?: itemList[];
  Payments?: itemList[];
  Claims?: itemList[];
  General?: itemList[];
  Notification?: itemList[];
}
export interface itemList {
  answer: string;
  category: string;
  orderId: string;
  question: string;
}

const FAQpageContainer = styled.div`
  margin: 0;
`;
function GeneraliSupportList() {
  const data = [
    {
      tittle: 'life.questions.moduletitle0',
      svg: userGuide,
    },
    {
      tittle: 'life.questions.moduletitle1',
      svg: homeMembershipIcon,
    },
    {
      tittle: 'life.questions.moduletitle2',
      svg: policies,
    },
    {
      tittle: 'life.questions.moduletitle3',
      svg: person,
    },
    {
      tittle: 'life.questions.moduletitle4',
      svg: payment,
    },
    {
      tittle: 'life.questions.moduletitle5',
      svg: claim,
    },
    {
      tittle: 'life.questions.moduletitle6',
      svg: NotificationBellRed,
    },
  ];
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [lifeFaqList, setLifeFaqList] = useState<newLifeFaqList | null>(null);
  const [lifeFaqListzh, setLifeFaqListzh] = useState<newLifeFaqList | null>(null);
  const { data: lifeData, error: lifeError } = useLifeFaq('en');
  const { data: lifeDatazh, error: lifeErrorzh } = useLifeFaq('zh');

  useEffect(() => {
    if (lifeData && lifeData.lifeFaq.length > 0) {
      const sliceLifeData = lifeData.lifeFaq.map((item) => {
        return {
          ...item,
          question: item.question,
        };
      });
      const newLifeFaqList: newLifeFaqList = sliceLifeData.reduce((acc, item) => {
        const category = item.category as keyof newLifeFaqList;
        acc[category] = acc[category] || [];
        if (!acc[category]) {
          acc[category] = [];
        } else {
          acc[category]?.push(item);
        }
        return acc;
      }, {} as newLifeFaqList);
      setLifeFaqList(newLifeFaqList);
      console.log(newLifeFaqList, 'en--------------------------------------------');
    }
  }, [lifeData]);

  useEffect(() => {
    if (lifeDatazh && lifeDatazh.lifeFaq.length > 0) {
      const sliceLifeData = lifeDatazh.lifeFaq.map((item) => {
        return {
          ...item,
          question: item.question,
        };
      });
      const newLifeFaqList: newLifeFaqList = sliceLifeData.reduce((acc, item) => {
        const category = item.category as keyof newLifeFaqList;
        acc[category] = acc[category] || [];
        if (!acc[category]) {
          acc[category] = [];
        } else {
          acc[category]?.push(item);
        }
        return acc;
      }, {} as newLifeFaqList);
      setLifeFaqListzh(newLifeFaqList);
      console.log(newLifeFaqList, 'zh--------------------------------------------');
    }
  }, [lifeDatazh]);

  if (!lifeData && !lifeError && !lifeDatazh && !lifeErrorzh) return <Spinner />;

  if (lifeError || lifeErrorzh) return <GenericResult />;

  const TodetaileEven = (v: string) => {
    if (v == 'contactUs') {
      navigate('/ContactUs');
    } else if (v == 'life.questions.moduletitle0') {
      navigate('/LifeFaqDetailsPage', {
        state: { title: 'life.questions.title', listData: lifeFaqList?.General, listDatazh: lifeFaqListzh?.General },
      });
    } else if (v == 'life.questions.moduletitle1') {
      navigate('/LifeFaqDetailsPage', {
        state: {
          title: 'life.questions.moduletitle1',
          listData: lifeFaqList?.Login,
          listDatazh: lifeFaqListzh?.Login,
        },
      });
    } else if (v == 'life.questions.moduletitle2') {
      navigate('/LifeFaqDetailsPage', {
        state: {
          title: 'life.questions.moduletitle2',
          listData: lifeFaqList?.Policies,
          listDatazh: lifeFaqListzh?.Policies,
        },
      });
    } else if (v == 'life.questions.moduletitle3') {
      navigate('/LifeFaqDetailsPage', {
        state: {
          title: 'life.questions.moduletitle3',
          listData: lifeFaqList?.Profile,
          listDatazh: lifeFaqListzh?.Profile,
        },
      });
    } else if (v == 'life.questions.moduletitle4') {
      navigate('/LifeFaqDetailsPage', {
        state: {
          title: 'life.questions.moduletitle4',
          listData: lifeFaqList?.Payments,
          listDatazh: lifeFaqListzh?.Payments,
        },
      });
    } else if (v == 'life.questions.moduletitle5') {
      navigate('/LifeFaqDetailsPage', {
        state: {
          title: 'life.questions.moduletitle5',
          listData: lifeFaqList?.Claims,
          listDatazh: lifeFaqListzh?.Claims,
        },
      });
    } else if (v == 'life.questions.moduletitle6') {
      navigate('/LifeFaqDetailsPage', {
        state: {
          title: 'life.questions.moduletitle6',
          listData: lifeFaqList?.Notification,
          listDatazh: lifeFaqListzh?.Notification,
        },
      });
    }
  };
  return (
    <FAQpageContainer className="FAQ">
      <GreetingSection pageName={t('life.questions.title')} showicon={false} />
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 20 }}
          lg={{ span: 24 }}
          style={{
            background: 'white',
            maxWidth: '1384px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="centerlist"
        >
          <List
            style={{ background: 'white', width: '672px' }}
            size="large"
            className="liststyle"
            bordered
            dataSource={data}
            renderItem={(item) => (
              <List.Item
                style={{ display: 'flex', fontFamily: 'Roboto400', cursor: 'pointer' }}
                onClick={() => {
                  TodetaileEven(item.tittle);
                }}
              >
                <span style={{ fontSize: '20px' }}>
                  {/* <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" /> */}
                  <img
                    alt={item.tittle}
                    src={item.svg}
                    style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }}
                  />
                  {t(item.tittle)}
                </span>
                <span>
                  <img src={ChevronRight} style={{ margin: '0  10px 0 0', width: '8px', height: '14px' }} />
                </span>
              </List.Item>
            )}
          />
        </Col>
      </Row>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 20 }}
          lg={{ span: 24 }}
          style={{
            background: '#fff',
            maxWidth: '1384px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
          className="centerlist2"
        >
          <div
            className="header2"
            style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}
          >
            <div className="headertittle"> {t('questions.contactGenerali')}</div>
          </div>
          <div className="buttondiv" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              block
              className="button"
              onClick={() => {
                TodetaileEven('contactUs');
              }}
              style={{ cursor: 'pointer' }}
            >
              {t('questions.contactText')}
            </Button>
          </div>
        </Col>
      </Row>
    </FAQpageContainer>
  );
}
export default GeneraliSupportList;
